__turbopack_context__.v({
  "bars": "ldgnoG_bars",
  "barsBlackColor": "ldgnoG_barsBlackColor",
  "barsClose": "ldgnoG_barsClose",
  "barsWhiteColor": "ldgnoG_barsWhiteColor",
  "catelogMenu": "ldgnoG_catelogMenu",
  "dactive": "ldgnoG_dactive",
  "dscroll": "ldgnoG_dscroll",
  "dtoggle": "ldgnoG_dtoggle",
  "error": "ldgnoG_error",
  "headerSearch": "ldgnoG_headerSearch",
  "headerSection": "ldgnoG_headerSection",
  "headerSectionBlackColor": "ldgnoG_headerSectionBlackColor",
  "headerSectionBlackColorError": "ldgnoG_headerSectionBlackColorError",
  "headerSectionDBlock": "ldgnoG_headerSectionDBlock",
  "headerSectionDNone": "ldgnoG_headerSectionDNone",
  "headerSectionEBBPadding": "ldgnoG_headerSectionEBBPadding",
  "headerSectionHeight0": "ldgnoG_headerSectionHeight0",
  "headerSectionHeight20": "ldgnoG_headerSectionHeight20",
  "headerSectionMobileHeight0": "ldgnoG_headerSectionMobileHeight0",
  "headerSectionOrder1": "ldgnoG_headerSectionOrder1",
  "headerSectionOrder2": "ldgnoG_headerSectionOrder2",
  "headerSectionPadding": "ldgnoG_headerSectionPadding",
  "headerSectionWhiteColor": "ldgnoG_headerSectionWhiteColor",
  "headerSectionWhiteColorError": "ldgnoG_headerSectionWhiteColorError",
  "item": "ldgnoG_item",
  "logo": "ldgnoG_logo",
  "menu": "ldgnoG_menu",
  "menuBlackColor": "ldgnoG_menuBlackColor",
  "msgBlock": "ldgnoG_msgBlock",
  "search": "ldgnoG_search",
  "show": "ldgnoG_show",
  "subMenu": "ldgnoG_subMenu",
  "subscribe": "ldgnoG_subscribe",
  "subscribeNL": "ldgnoG_subscribeNL",
  "success": "ldgnoG_success",
  "textBox": "ldgnoG_textBox",
  "toggle": "ldgnoG_toggle",
  "toggleDInBlock": "ldgnoG_toggleDInBlock",
  "toggleDNone": "ldgnoG_toggleDNone",
  "vhidden": "ldgnoG_vhidden",
});
